import * as tslib_1 from "tslib";
import { BaseModel } from '../_base/model.class';
var Company = /** @class */ (function (_super) {
    tslib_1.__extends(Company, _super);
    function Company(_id, code, types, name, vatNumber, taxCode, email, pec, sdiCode, legalAddress, operativeAddress, phone, fax, webSiteUrl, legalName, legalLastName, legalResidentialAddress, legalTaxCode, legalEmail, subUsers, subProperties, subscription, phonebook, documents, createdBy, createdAt, updatedBy, updatedAt) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this.code = code;
        _this.types = types;
        _this.name = name;
        _this.vatNumber = vatNumber;
        _this.taxCode = taxCode;
        _this.email = email;
        _this.pec = pec;
        _this.sdiCode = sdiCode;
        _this.legalAddress = legalAddress;
        _this.operativeAddress = operativeAddress;
        _this.phone = phone;
        _this.fax = fax;
        _this.webSiteUrl = webSiteUrl;
        _this.legalName = legalName;
        _this.legalLastName = legalLastName;
        _this.legalResidentialAddress = legalResidentialAddress;
        _this.legalTaxCode = legalTaxCode;
        _this.legalEmail = legalEmail;
        _this.subUsers = subUsers;
        _this.subProperties = subProperties;
        _this.subscription = subscription;
        _this.phonebook = phonebook;
        _this.documents = documents;
        _this.createdBy = createdBy;
        _this.createdAt = createdAt;
        _this.updatedBy = updatedBy;
        _this.updatedAt = updatedAt;
        _this.setRequiredFields([
            '_id',
            'types',
            'name',
            'email',
            'legalAddress',
            'createdBy',
            'createdAt',
        ]);
        return _this;
    }
    return Company;
}(BaseModel));
export { Company };
